export default __webpack_public_path__ + "static/media/ic_bome_40.9ca6e5ad.png";